import { reactive, computed } from 'vue';
import strapiApi from '@/services/strapiApi';
import { userStore } from './userStore';
import { connectSocket, disconnectSocket } from '@/services/socketService';

export const notificationStore = reactive({
  notifications: [],
  jobs: {},

  unreadCount: computed(() => {
    return notificationStore.notifications.filter(n => !n.read).length;
  }),

  async fetchNotifications() {
    if (!userStore.currentUser) return;

    try {
      const response = await strapiApi.getNotifications(userStore.currentUser.id);
      this.notifications = response.data.data;
    } catch (error) {
      console.error("Erreur lors du chargement des notifications:", error);
    }
  },

  initSocket(userId) {
    const socket = connectSocket(userId);
    socket.on('notification', (notif) => {
      this.notifications.unshift(notif);
    });
    socket.on('job:progress', ({ jobId, percent, message }) => {
      this.jobs[jobId] = { percent, message };
    });
    socket.on('job:done', ({ jobId }) => {
      delete this.jobs[jobId];
    });
    socket.on('job:error', ({ jobId, message }) => {
      if (this.jobs[jobId]) this.jobs[jobId] = { percent: -1, message };
      setTimeout(() => { delete this.jobs[jobId]; }, 5000);
    });
  },

  destroySocket() {
    disconnectSocket();
  },

  async markAsRead(notification) {
    if (notification.read) return;

    try {
      await strapiApi.updateNotification(notification.documentId, { read: true });
      const index = this.notifications.findIndex(n => n.id === notification.id);
      if (index !== -1) {
        this.notifications[index].read = true;
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la notification:", error);
    }
  },

  clearNotifications() {
    this.notifications = [];
  },
});
